/**
 * Queue for EventMessages that is a singleton and allows for synchronous usage backed up to both in-memory and local storage.
 * @module harbinger/eventProcessor/synchronousQueue
 */

export { default } from './synchronousQueue'
export { default as constants } from './constants'
